import { Icon } from "./Icon.tsx";

/** "Background Image" icon — a simple picture-frame glyph. */
export function BackgroundImageIcon() {
  return (
    <Icon>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="9" cy="10" r="1.7" fill="currentColor" stroke="none" />
      <path d="M4 17l6-6 4 4 3-3 4 4" />
    </Icon>
  );
}
